// 冷蔵庫: 縦長の箱、ドア分割線あり
import { Box } from '@react-three/drei'

export default function RefrigeratorMesh({ width, height, depth, position, color, isSelected }) {
    const freezerHeight = height * 0.25

    return (
        <group>
            {/* 本体 */}
            <Box args={[width, height, depth]} position={position}>
                <meshStandardMaterial color={color} metalness={0.3} roughness={0.4} opacity={isSelected ? 1 : 0.9} transparent />
            </Box>

            {/* 冷凍室ドアライン */}
            <Box args={[width * 0.9, height * 0.02, depth * 0.02]} position={[0, position[1] + height / 2 - freezerHeight, depth / 2 + 0.005]}>
                <meshStandardMaterial color={color} metalness={0.2} roughness={0.5} />
            </Box>

            {/* 冷凍室ハンドル */}
            <Box args={[width * 0.03, freezerHeight * 0.5, depth * 0.03]} position={[width * 0.35, position[1] + height / 2 - freezerHeight / 2, depth / 2 + 0.02]}>
                <meshStandardMaterial color="#666" metalness={0.4} roughness={0.3} />
            </Box>

            {/* 冷蔵室ハンドル */}
            <Box args={[width * 0.03, (height - freezerHeight) * 0.3, depth * 0.03]} position={[width * 0.35, position[1] - freezerHeight / 2, depth / 2 + 0.02]}>
                <meshStandardMaterial color="#666" metalness={0.4} roughness={0.3} />
            </Box>

            {/* ワイヤーフレーム */}
            <Box args={[width, height, depth]} position={position}>
                <meshBasicMaterial color={color === '#ef4444' ? '#ef4444' : '#0ea5e9'} wireframe opacity={isSelected ? 0.6 : 0.3} transparent />
            </Box>

            {/* 選択時のハイライト */}
            {isSelected && (
                <Box args={[width, height, depth]} position={position}>
                    <meshBasicMaterial
                        color="#fbbf24"
                        wireframe
                        opacity={0.8}
                        transparent
                    />
                </Box>
            )}
        </group>
    )
}
